<template>
	<div class="callobject">	
		<div  class="mobilePadding">             
			<div class="flatHeader px-2">				
				<div class="row mx-0 align-items-center">
					<div class="bntGroup">
						<base-button type="primary" class="groupfloor" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
					</div>
							
				</div>
			</div>
			<div class="row" v-if="typeof objData[0] != 'undefined'">
				<div class="col-md-12 col-lg-6">
				<card class="collapseArrow">
					<collapse :name="'c-c_'+ objData[0].id" :activeIndex="objTabs.photo==true?0:-1" class="">
						
						<collapse-item @activate="onCollapsePhoto">
							

							<div slot="title" class="col-title">
								<h3>ФОТО ОБЪЕКТА</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.photo">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.photo">скрыть</span>
							</div> 
							<SecondObj :objData="objData[0]"/>
							
						</collapse-item>
						
					</collapse>
				</card>
				</div>
				<div class="col-md-12 col-lg-6">
				<card class="collapseArrow">
					<collapse :name="'c-m_'+ objData[0].id" :activeIndex="objTabs.main==true?0:-1" v-if="typeof objData[0]!='undefined'" class="">
						<collapse-item @activate="onCollapseMain">
							<div slot="title" class="col-title">
								<h3>ID {{objData[0].id}}, {{objData[0].categoryName}}</h3>	
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.main">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.main">скрыть</span>
							</div>
							<SecondObjCC :objData="objData[0]" :showClassification="false"/>
								
							<!-- <h4 class="text-success mt-3 text-center mb-0" v-if="objData[0].result_name">Текущая классификация звонка: {{objData[0].result_name}}</h4>	 -->

							<template v-if="CCMBData[0].status_id == 1 /*|| CCMBData[0].status_id == 2*/">
								<div class="d-flex align-items-center justify-content-center">
									<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
									<h4 class="mt-3 mx-2">Позвоните по объявлению</h4>	
									<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
								</div>
								<div class="callform row align-items-end mx-0">
									<div class="col-sm-6 col-12 pl-sm-0 pr-sm-2 px-0">
										<span v-if="CCMBData[0].isReplacementPhone">Телефон подменный: {{ CCMBData[0].ClientPhoneManual }}</span>
										<base-input
												label="Номер телефона"
												name="phone"
												v-model="clientPhone"
												placeholder="+79XXXXXXXXX"
												mask="phone"
											>
										</base-input>
										
									</div>
									<div class="col-sm-6 col-12 pr-sm-0 pl-sm-2 px-0">
										<div class="flatPass-btn">
											<base-button type="success" class="my-0" simple @click="$GVO.Call(clientPhone,'CC_MY_BASE',$route.params.cc_my_id)">Позвонить</base-button>
											<!--base-button type="success" simple @click="$GVO.Call('79112223344','CC',objData[0].id)">Позвонить</base-button-->	
										</div>
									</div>
									<p> <i class="tim-icons text-danger icon-alert-circle-exc"></i> Пожалуйста, проверьте соответствие номера телефона с номером на рекламной площадке и, в случае несоответствия, исправьте номер перед звонком</p>

								</div>
								<div class="d-flex align-items-center justify-content-center">
									<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
									<h4 class="mt-3 mx-2">Зафиксируйте результат звонка</h4>	
									<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
								</div>

								<div class="callform addClient mt-1">
									<div class="col-md mb-3 px-0">
										<label for="" class="col-form-label">Результат разговора</label>
										<el-select						
											class="col-md px-0 select-primary  overflow-overlay"						
											placeholder="Результат разговора"
											size="large"
											v-model="callResult"
											@change="changeClass"
										>
											<el-option
												class="select-primary long-select"
												v-for="option in masCallResults"
												:key="option.value"
												:label="option.label"
												:value="option.value"
											>
											</el-option>
										</el-select>
										<div class="btnGroup" v-if="callResult != '5' && callResult != '1' && callResult != '2' && callResult != '0'">
											<base-button  type="success" simple @click="SaveClass">Сохранить</base-button>
										</div>
									</div>
									<div v-if="currentForm!==false">
										<h4 class="mt-1">{{ currentForm.title }}</h4>
										<ReFormPrinter 
										v-if="apiForms[callResult]!==true"
										:masFormConfig="apiForms[callResult]"
										:objSaveApiMethod="currentApiFormMethod"
										:SuccessGo="SuccessGo" 
										SuccessBtnText="Сохранить" 
										/>
										<div v-else>Загрузка формы {{ apiForms[callResult] }}</div>
									</div>

								</div>
							</template>
						</collapse-item>
					</collapse> 
				</card>
				</div>
					<div class="col-md-12 col-lg-6">
					<card class="collapseArrow">
					
					<collapse :name="'c-c_'+$route.params.cc_my_id" :activeIndex="objTabs.lenta==true?0:-1" class="">
						<collapse-item :name="'c-c_'+$route.params.cc_my_id" @activate="onCollapseLenta">
							<div slot="title" class="col-title">
								<h3>ЛЕНТА</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.lenta">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.lenta">скрыть</span>
							</div>
							<ReClientLentaNest :id="$route.params.cc_my_id" obj="CC_MY_BASE" default_message_type="Классификация"/>
						</collapse-item>
					</collapse>
					</card>
					</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Select, Option, Tooltip } from "element-ui";	
import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
// import ReFormPrinterOptions from 'src/our_components/FormPrinter/ReFormPrinterOptions.vue';
import ReClientLentaNest from "src/our_components/ReClientLentaNest.vue";
import {eventEmitter} from "src/plugins/globalComponents.js";
import SecondObj from '../our_components/Objects/SecondObj.vue';
import SecondObjCC from '../our_components/Objects/SecondObjCC.vue';

export default {
	name: 'CC_MY_BASE_edit-page',
	components: {
		Collapse,
		CollapseItem,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,
		ReFormPrinter,
		// ReFormPrinterOptions,
		ReClientLentaNest,
		SecondObj,
		SecondObjCC,
	},
	props: {
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		// flatPass: {
		// 	type: String,
		// 	default: 'ID 254, 1ккв',
		// },
		// objectPass: {
		// 	type: String,
		// 	default: 'Общая информация',
		// },
		currentTab: {
			type: String,
			default: '',
		}
	},
	data () {
		return {
			ver: 1,
			// masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			// masAllFormParams_ReCall: this.currentFormConfig_ReCall(),
			// masAllFormParams_Reject: this.currentFormConfig_Reject(),
			// masAllFormParams_addMyBase: [],//this.currentFormConfig_addMyBase(),
			// currentApiFormMethod: this.currentApiFormMethodComp(),
			apiForms:{}, // Место где будем хранить формы
			masCallResults: [
				{'label':'Не классифицировано','value':'0'},
				{'label':'Создать услугу','value':'1'},
				{'label':'Отказ от сотрудничества','value':'2'},
				{'label':'Объект продан','value':'3'},
				{'label':'Снято с публикации','value':'4'},
				{'label':'Перезвонить','value':'5'},
			],
			callResult:'0',
			currentForm: false,
			isShown: false,
			bIsLoading: true,
			clientPhone: '',
			objData: [],
			CCMBData:[],
			objAgents:[],
			objLenta:[],
			masImgs:'',
			masAgents:[],
			objTabs: {photo: true, main: true, map:true, lenta:true},
			activeItem: null,
			descr: '',
		}
	},
	watch: {

		callResult(val){
			const forms={
				'1' : {
					title:'Добавьте клиента' ,
					form: this.currentFormConfig
				},
				'5': {
					title: 'Перезвонить',
					form: this.currentFormConfig_ReCall
				},
				'2': {
					title: 'Отказ от сотрудничества',
					form: this.currentFormConfig_Reject
				}
			}
			if(forms[val]){
				const {query, ...form} = forms[val];
				if(!this.apiForms[val]){
					this.apiForms[val] = true;
					forms[val].form().then(res=>{
						let newData = {...this.apiForms};
						newData[val] = res;
						this.apiForms = newData
					});
					
				}
				this.currentForm = form;
			}else{
				this.currentForm = false;
			}
		},
	},
	computed: {
		
	},
	methods: {		
		
		currentFormConfig() {
			return this.$GVO.ApiCall('CC_MY_BASE.GET_FORM_ClientAdd',{flt:{id: this.$route.params.cc_my_id},data:{phone: this.clientPhone}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					return objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentFormConfig_ReCall() {
			return this.$GVO.ApiCall('CC_MY_BASE.GET_FORM_ReCall',{flt:{id: this.$route.params.cc_my_id}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					return objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentFormConfig_Reject(){
			return this.$GVO.ApiCall('CC_MY_BASE.GET_FORM_Reject',{flt:{}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					return objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},

		currentApiFormMethodComp(){
			return {
				apiMethod:'CC_MY_BASE.INSUPD',
				apiParam:{
					flt:{
						id:this.$route.params.cc_my_id
					},
					iData:[],
					addData:{
						result_id:this.callResult,
						result_name:this.getClassificName(this.callResult)
					}
				}
			};
		},
		/*
		currentApiFormMethodComp(){
			return {apiMethod:'COLD_CALLS.INS',apiParam:{iData:[],addData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.$GVO.GetCatValName('cat_coldcall_type', this.callResult)}}};
		},
		*/
		changeClass(){
			this.currentApiFormMethod = this.currentApiFormMethodComp();//{apiMethod:'COLD_CALLS.INS',apiParam:{iData:[],addData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.$GVO.GetCatValName('cat_coldcall_type', this.callResult)}}};
		},
		SuccessGo(evt,dopParam){
			// console.log('successgo', evt,dopParam);
			eventEmitter.$emit('reload_lenta');
			// location.pathname='/data/CC_MY_BASE/';
			this.$router.push('/data/CC_MY_BASE/');

		},
		/*
		SuccessGo_ClientAdd(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},	
		SuccessGo_ReCall(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},
		SuccessGo_addMyBase(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},
		*/
		SaveClass(){
			this.$GVO.Api.CC_MY_BASE.INSUPD({flt:{
						id:this.$route.params.cc_my_id
					},
					iData:[],
					addData:{
						result_id:this.callResult,
						result_name:this.getClassificName(this.callResult)
					}
			}).then(objApi=>{
				if(objApi.success === true){ 
					this.SuccessGo(null, objApi);
				}
			});
			/*
			this.$GVO.ApiCall('CC_MY_BASE.INS',{iData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.getClassificName(this.callResult)}})
			.then((objApi) => {
				console.log(objApi.data);
				if(objApi.success === true){ 
					//console.log(objApi.data);
					eventEmitter.$emit('reload_lenta');
				}
			}).catch(errorObjApi => { console.log(errorObjApi); });
			*/
		},
		backByHistory(){
			// this.$router.back();
			this.$router.go(-1);
			// console.log(localStorage);
		},
		getObject(obj_id){
			// console.log('getObject',this.$route.params.obj_id);
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof obj_id!= 'undefined'){
				this.$GVO.ApiCall('COLD_CALLS.GET',{flt:{ act:1, obj_id:obj_id, c2p:1 }})
				.then((objApi) => {
					this.bIsLoading = false;
					// console.log(objApi.data);
					if(objApi.success === true){ 
						//console.log(objApi.data);
						this.objData = this.$GVO.unlinkObject(objApi.data);
						// this.currentFormConfig_addMyBase();
						this.updateClientPhone();
					}else{
						this.objData = [];
					} 
				}).catch(errorObjApi => {this.objData = []; console.error(errorObjApi); });
			}
		},
		updateClientPhone(){
			let row = this.CCMBData[0]||{};
			let obj = this.objData[0]||{};
			this.clientPhone = row.isReplacementPhone ? (obj.salesAgentPhone||'') : this.CCMBData[0].ClientPhoneManual;
		},
		getCCMBData(){
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.$route.params.cc_my_id != 'undefined'){
				this.$GVO.ApiCall('CC_MY_BASE.GET',{flt:{ act:1, id:this.$route.params.cc_my_id, c2p:1 }})
				.then((objApi) => {
					this.bIsLoading = false;
					// console.log(objApi.data);
					if(objApi.success === true){ 
						// console.log(objApi.data);
						this.CCMBData = this.$GVO.unlinkObject(objApi.data);
						this.updateClientPhone();
						this.getObject(this.CCMBData[0].obj_id);
					}else{
						this.CCMBData = [];
					} 
				}).catch(errorObjApi => {this.objData = []; console.error(errorObjApi); });
			}
		},
		onCollapsePhoto(opt){
			this.objTabs.photo = opt;
			this.saveTabs();
		},
		onCollapseMain(opt){
			this.objTabs.main = opt;
			this.saveTabs();
		},
		onCollapseMap(opt){
			this.objTabs.map = opt;
			this.saveTabs();
		},
		onCollapseLenta(opt){
			this.objTabs.lenta = opt;
			this.saveTabs();
		},
		saveTabs() {
			const parsed = JSON.stringify(this.objTabs);
			localStorage.setItem('objTabs', parsed);
		},
		cleanDescription(descr){
			//console.log(descr);	
			descr = (descr||'').replace(/\u2028/g,' ');
			return descr;
		},
		getClassificName(value){
			let strRet = value;
			//console.log('masCallResults',this.masCallResults);
			if(typeof this.masCallResults != 'undefined'){
				for (let i = 0; i < this.masCallResults.length; i++) {
					if(this.masCallResults[i].value==value) strRet = this.masCallResults[i].label;
				}
			}
			return strRet;
		}

	},
	mounted(){

	},
	created(){
		eventEmitter.$on('reload_lenta', this.getCCMBData);
		this.getCCMBData();
		/*
		this.$GVO.LoadCatPromise('cat_coldcall_type').then((ret)=>{
			this.masCallResults = this.$GVO.getCatToSelect('cat_coldcall_type');
		}).catch(errorRet => console.log(errorRet));
		*/
		if (localStorage.getItem('objTabs')) {
			try {
				this.objTabs = JSON.parse(localStorage.getItem('objTabs'));
				if(this.$GVO.isEmpty(this.objTabs)){
					this.objTabs = {photo:true,main:true,map:true,lenta:true};
				}
			} catch(e) {
				localStorage.removeItem('objTabs');
			}
		}
		
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('reload_lenta', this.getCCMBData);
	},
}
</script>
<style scoped>

.callobject {width: 100%;}
.flatHeader {display: flex; padding: 15px; justify-content: space-between; flex-wrap: wrap;}
.flatHeader-btn {display: flex; flex-wrap: wrap;}
.flatTitles {display: flex; flex-direction: column;}
.flatTitles h4 {margin-bottom: 5px;}

.flatPass {flex-shrink: 2;}
.structure-btns > button {width: 100%;}
.icon-folder {width: 18px; height: 18px; background-image: url('/img/icons/folder.svg'); background-repeat: no-repeat;  margin: 0px 7px 3px 0px;}
.callobject >>> .form-options-group {width: 100%;}
.callobject >>> .btnGroup {display: flex; justify-content: space-around;}
.callobject >>> .map{height: auto;}

/*===carousel===============================*/

.callobject >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.callobject >>>  button:focus {outline: none!important;}
.callobject >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.callobject >>> .el-carousel__arrow--right {right: 0;}
.callobject >>> .el-carousel__arrow--left {left: 0;}
.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/73b0903ac774c473d1cd176b2fbe999f.jpeg") no-repeat center;
  background-size: contain;
} /*план поэтажный*/ 
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/9bht27nx4iuqcw3n0s4wyns4.png") no-repeat center;
  background-size: contain;
} /*план кв*/ 

/*===collapse===============================*/

.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}


.objectInfo, .priceFlow  {display: flex; justify-content: space-between; flex-wrap: wrap;}
.objectInfo h4:first-child {margin-right: 15px;}
.objectAddress {display: flex; flex-wrap: wrap;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.service-title {display: flex; flex-wrap: wrap;}
.marker::before {
	content: "\20DD";
	color: #01B0E0;
	padding-right: 18px;
	font-size: 12px;
	font-weight: normal;
}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row > p:first-child {min-width: 100px; margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {position: relative; padding-left: 10px;}
.objectPass-row p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: 3px;
	top: 9px;
} 
.collapseRegular >>> .card-collapse {border-right: unset!important;}
.collapseRegular >>> .card-collapse .card:not(.card-cinc) .card-header a {
    color: #01B0E0;
}
.collapseRegular >>> .card-header {padding-bottom:0px!important;}
/* .callobject .my-row .card-collapse{
	border-right: 1px solid #01b0e0;
	height: fit-content;
	display: inline-block;
	width: 50%;
	padding: 0px;
} */
.callobject .my-row .collapseArrow{
	/* border-right: 1px solid #01b0e0; */
	height: fit-content;
	display: inline-block;/**/
	width: 49%;
	/* width: 50%; */
	padding: 0px;
}
.callobject >>> .card-collapse[name^="c-"] > .card > .card-header{
	border-bottom: 2px solid #01B0E0;  /*medium вместо 2px,  как красивше*/
	background-color: #01b0e01b!important; 
	box-shadow: 0 9px 7px -3px rgb(158 119 243 / 40%);
}
.callobject >>> .card-collapse[name^="c-"] .card:not(.card-cinc) .card-header a[data-toggle="collapse"] i {bottom: -7px; display: none;}

.callobject .my-row{
	padding: 0px 20px;
}
.callobject >>> .my-float-pin > div:nth-child(2){
	border-right: 0px;
	float: right;
}

.callobject >>> .card-collapse .postForm {
    background: #27293d;
}
.callobject >>> .clientExists {display: none;}
.callobject >>> .form-options .bntGroup > * {width: fit-content;}

.callobject >>> .addClient {border: 1px dashed #ff8d72; border-radius: 6px; padding: 10px 15px;}
.callobject >>> .callform {border: 1px dashed #01B0E0; border-radius: 6px; padding: 10px 15px;}



.callobject >>> .classificationStatus {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	width: 100%;
    padding: 15px;
    border-radius: 6px;
	background: linear-gradient(90deg, #1d83bd 0%, #00BF9A 100%);
	color: #fff;
}
.callobject >>> .classificationStatus h4{color: #fff;}


@media (max-width: 768px) {	
	.flatPass {margin-top: 20px; padding: 0px 10px 0px 5px!important;}
	.flatPass-btn {flex-wrap: wrap;}
	.flatPass-btn > button:first-child {margin-right: 0px;}
	.calcs {order: 1; margin-bottom: 20px;}
	.banks {order: 2; padding-right: 0px;}
	.monthly-pay h4 {margin-bottom: 0px;}
	.calcs {padding-left: 0px;}
	.bank-header {flex-wrap: wrap;}
	.mortgage-calc .btn, .flatHeader-btn {margin-top: 15px; width: 100%;}
	.flatHeader {padding: 15px 0px;}
	.cell-agent {flex-wrap: wrap;}
	.callobject .my-row .card-collapse{
		border-right: 0px;
		display: block;
		width: 100%;			
	}
	.callobject .my-row > div:nth-child(2){
		float: none;
	}
	.mobilePadding > .card-body {padding: 15px 0;}
	.callobject >>> .card-collapse .card-body {padding: 5px 0;}
	.task-pl-3 {padding-left: 0px;} 
	.callobject >>> .map {display: none;}
	.clientPage .my-row .card-collapse, .clientPage .my-row .collapseArrow{
			border-right: 0px;
			display: block;
			width: 100%;			
		}
}


@media (max-width: 520px){
	.callobject .my-row{
		padding: 0px 8px;
	}
}

</style>
